import type { Mission } from '../missions.ts'

export const bep: Mission = {
  id: "bep",
  name: "Bureau of Engraving and Printing",
  short: "BEP",
  call: "Engraving",
  kind: "subagency",
  parent: "treasury",
  url: "https://www.bep.gov/",
  established: 1862,
  palette: {
    primary: "#1b1b1b",
    secondary: "#162e51",
    accent: "#175624",
  },
  colorSource: {
    kind: "site",
    url: "https://www.bep.gov/",
  },
  motif: "scroll",
  mission: {
    text: "The Bureau of Engraving and Printing’s mission is to develop and produce United States currency notes, trusted worldwide.",
    url: "https://www.bep.gov/about-bep",
  },
  fact: {
    text: "In 1877, BEP became the sole producer of all United States currency.",
    url: "https://www.bep.gov/currency/history",
  },
  seal: {
    file: "public/seals/bep.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Bureau_of_Engraving_and_Printing.svg",
  },
  identifier: {
    about: "https://www.bep.gov/about-bep",
    accessibility: "https://www.bep.gov/footer/accessibility-statement",
    foia: "https://www.bep.gov/footer/foia",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://oig.treasury.gov/",
    performance: "https://www.bep.gov/about-bep/reporting-and-planning",
    privacy: "https://www.bep.gov/footer/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/bep-washington.jpg",
        small: "/media/bep-washington-sm.jpg",
        alt: "The long limestone colonnade of the Bureau of Engraving and Printing main building in Washington, seen across the water under a blue sky with white clouds.",
        title: "Bureau of Engraving and Printing, Washington, D.C., October 8, 2023",
        creator: "Harrison Keely",
        source: "https://commons.wikimedia.org/wiki/File:The_Bureau_of_Engraving_and_Printing_(BEP)_in_Washington,_D.C.jpg",
        license: "CC BY 4.0",
      },
    ],
  },
}
